import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content"]

    connect() {
        console.log("Dropdown toggler controller connected")
    }

    toggle(event) {
        const element = event.currentTarget
        const elementToShow = $(element).find(":selected").data("toggle") || element.dataset.toggle

        this.contentTargets.forEach((element, index) => {
            let elementId = `#${element.id}`
            element.classList.toggle("hidden", elementId != elementToShow)
        })
    }
}
